import React, { useEffect, useState } from "react";
import { Container, Button } from "reactstrap";
import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import { toast } from "react-toastify";
import { fetchFilterListForAllocation } from "../../api/approval";
import { management_approved_list } from "../../api/requisition";
import ProductRightSideBar from "./ProductRightSideBar";
import dayjs from "dayjs";

const ManagementApprove = () => {
  const dispatch = useDispatch();

  const [showList, setShowList] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [gridLoad, setGridLoad] = useState(false);
  const [approvedRows, setApprovedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [rowValue, setRowValue] = useState({});
  const [sidebarLoad, setSidebarLoad] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  useEffect(()=>{
    dispatch(StorePageHeaderName("Management Approval"));

  },[])

  const toggleList = () => {
    setShowList(!showList);
  };

  document.title = "Management Approval";

  const columns = [
    {
      field: "sl_no",
      headerName: "Sl.No",
      flex: 0.5,
      resizable: false,
    },
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      headerClassName: "break-header",
      cellClassName: "product_name_wrap",
      width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "segment",
      headerName: "Segment",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "vertical",
      headerName: "Vertical",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "product_name",
      headerName: "Product Name",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "req_qty",
      headerName: "REQ QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "approved_qty",
      headerName: "Approved QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "remaining_qty",
      headerName: "Remaining QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "added_qty",
      headerName: "Addes QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      // width: 160,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "value",
      headerName: "Value",
      resizable: false,
      sortable: false,
      width: 160,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => handleEyeIconClick(params)}
        >
          <VisibilityIcon />
        </div>
      ),
    },
  ];

  const handleEyeIconClick = async (params) => {
    try {
      setOpen(true);
      setSidebarLoad(true);
      setRowValue(params.row);
    } catch (error) {
      console.log("error in fetching products--", error);
      toast.error("Error in fetching products");
    }
  };

  const fetchFilterList = async () => {
    try {
      const list = await fetchFilterListForAllocation({
        filter_type: ["vendor", "product", "category"], isManagementApproval: 'managementApproval'
      });
      if (list.statusCode === 200) {
        if (list.data.response.categoryList.length > 0) {
          setCategoryOptions(list.data.response.categoryList);
        }
        if (list.data.response.productList.length > 0) {
          setProductOptions(list.data.response.productList);
        }
        if (list.data.response.vendorList.length > 0) {
          setVendorOptions(list.data.response.vendorList);
        }
      }
    } catch (error) {
      toast.error("Error in fetching vendor list for assign vendor");
      console.log(error);
    }
  };

  const fetchManagementApprovedList = async (
    product = null,
    vendor = null,
    category = null,
    start_date = null,
    end_date = null
  ) => {
    try {
      setGridLoad(true);
      const payload = {
        product,
        vendor,
        category,
        start_date,
        end_date,
      };
      const response = await management_approved_list(payload);
      const data = response.data.managementApprovedList.map((item, index) => ({
        id: `${item.v_code}&${item.approve_date.split('T')[0]}`,
        sl_no: index + 1,
        vendor_name: item.v_name,
        value: item.value,
      }));
      setApprovedRows(data);
    } catch (error) {
      toast.error(
        error.message || "An error occurred while fetching detailed list"
      );
    } finally {
      setGridLoad(false);
    }
  };

  const handleStartDateChange = (startDate) => {
    try {
      if (
        selectedEndDate &&
        startDate &&
        dayjs(startDate).isAfter(dayjs(selectedEndDate))
      ) {
        throw new Error("Start date cannot be after end date");
      }
      setSelectedStartDate(startDate);
    } catch (err) {
      setSelectedStartDate(null);
      toast.error(err.message);
    }
  };

  const handleEndDateChange = (endDate) => {
    try {
      if (
        selectedStartDate &&
        endDate &&
        dayjs(endDate).isBefore(dayjs(selectedStartDate))
      ) {
        throw new Error("End date cannot be before start date");
      }
      setSelectedEndDate(endDate);
    } catch (err) {
      setSelectedEndDate(null);
      toast.error(err.message);
    }
  };

  const handleSearch = () => {
    try {
      const product = selectedProduct ? selectedProduct.value : null;
      const vendor = selectedVendor ? selectedVendor.value : null;
      const category = selectedCategory ? selectedCategory.value : null;
      const start_date = selectedStartDate
        ? dayjs(selectedStartDate).format("YYYY-MM-DD")
        : null;
      const end_date = selectedEndDate
        ? dayjs(selectedEndDate).format("YYYY-MM-DD")
        : null;
      if (product || vendor || category || (start_date && end_date)) {
        fetchManagementApprovedList(
          product,
          vendor,
          category,
          start_date,
          end_date,
        );
      } else {
        throw new Error("Please select proper search parameter.");
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleReset = () => {
    setSelectedProduct(null);
    setSelectedVendor(null);
    setSelectedCategory(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    fetchManagementApprovedList();
  };

  useEffect(() => {
    if (showList) {
      fetchFilterList();
    }
  }, [showList]);

  useEffect(() => {
    fetchManagementApprovedList();
  }, []);
  return (
    <React.Fragment>
      {open && (
        <ProductRightSideBar
          open={open}
          setOpen={setOpen}
          sidebarLoad={sidebarLoad}
          setSidebarLoad={setSidebarLoad}
          rowValue={rowValue}
        />
      )}
      <div className="page-content">
        <Container fluid>
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <div>
                  <h4 className="mb-0 requisition_text">Management Approved</h4>
                </div>
                <button onClick={toggleList} className="filter_button">
                  <span className="me-2">
                    <TuneIcon />
                  </span>
                  Filter
                </button>
              </div>
              {showList && (
                <div
                  className="mt-2"
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="vendor"
                      options={vendorOptions}
                      sx={{ width: 220 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Vendor" />
                      )}
                      onInputChange={(event, newValue) => {
                        const getVal = vendorOptions.find(
                          (el) => el.label === newValue
                        );
                        setSelectedVendor(getVal || null);
                      }}
                      onChange={(event, newValue) => {
                        setSelectedVendor(newValue || null);
                      }}
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      value={selectedVendor}
                    />
                  </div>
                  <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="category"
                      options={categoryOptions}
                      sx={{ width: 220 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Category" />
                      )}
                      onInputChange={(event, newValue) => {
                        const getVal = categoryOptions.find(
                          (el) => el.label === newValue
                        );
                        setSelectedCategory(getVal || null);
                      }}
                      onChange={(event, newValue) => {
                        setSelectedCategory(newValue || null);
                      }}
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      value={selectedCategory}
                    />
                  </div>
                  <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="product"
                      options={productOptions}
                      sx={{ width: 220 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Product" />
                      )}
                      onInputChange={(event, newValue) => {
                        const getVal = productOptions.find(
                          (el) => el.label === newValue
                        );
                        setSelectedProduct(getVal || null);
                      }}
                      onChange={(event, newValue) => {
                        setSelectedProduct(newValue || null);
                      }}
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      value={selectedProduct}
                    />
                  </div>
                  <div className="d-flex">
                    {/* <button className="date_button" variant="contained" onClick={datepickeropenModal}>Select Date</button> */}
                    <div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="date_picker"
                          label="From Date"
                          value={selectedStartDate}
                          onChange={handleStartDateChange}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="ms-2">
                      <LocalizationProvider
                        className="date_picker"
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          className="date_picker"
                          label="To Date"
                          value={selectedEndDate}
                          onChange={handleEndDateChange}
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <button
                      className="me-2 search_button"
                      variant="outlined"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                    <ReplayIcon onClick={handleReset} />
                  </div>
                </div>
              )}
            </div>

            <Box
              sx={{
                height: 400,
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <DataGrid
                className="table_header_background"
                headerClassName="custom-header-cell"
                getRowHeight={() => "auto"}
                rows={approvedRows}
                columns={columns}
                loading={gridLoad}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnResize={true}
                componentsProps={{
                  cell: {
                    disableClick: true,
                  },
                }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    "& .MuiDataGrid-cell--textOverflow": {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                }}
              />
            </Box>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ManagementApprove;
